$(document).ready(function(){
  if (window.innerWidth <= 767) {
    $('.section-footer__title').click(function(){
      $('.section-footer__menu-block').removeClass('active');
      $(this).toggleClass('active');
      $(this).siblings('.section-footer__menu-block__menu').slideToggle('300');                                                                                  
    });
  } 
  
 // if (window.innerWidth <= 767) {
 //   $('body').css("padding-top","0px");
 //   $('.shopify-section.site--header.custom-site--header-mobile-none,.shopify-section.section-footer.custom-site--footer-mobile-none,.shopify-section.section-newsletter.custom-site--newsletter-mobile-none,.custom-cancel-button-mobile-hide,body #reamazejs-container,body #smile-ui-container,body #wishlisthero-floating-launcher-container, body #smile-ui-lite-container, .template-article .shopify-section.section-featured-collection,.template-article .shg-c.shg-btn-wrapper, .template-article .sharing.social-links,.template-article .other-products.other-products--articles .other-products__label').remove();
 //   setTimeout(function () { 
      
 //     $('body #reamazejs-container,body #wishlisthero-floating-launcher-container, div[data-wzb=InformationBar]').remove();
 //   }, 10000);
 // }
  
  // payment icons on product pages
  const prodBody = document.querySelector('.template-product');
  if (prodBody) {
    var paymentIconsFn = setInterval( ()=>{
      const payTrigger = document.querySelector('.afterpay-paragraph');
      document.querySelector('.afterpay-paragraph').style.display = "block";
      if (payTrigger) {payTrigger.classList.add('content-loaded')}
      if(payTrigger.classList.contains('content-loaded')){
        clearInterval(paymentIconsFn);
        let payIcons = `<svg width="74" height="15" viewBox="0 0 74 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M72.8744 2.87339L70.6458 1.59682L68.385 0.300907C66.8906 -0.556587 65.0227 0.520115 65.0227 2.248V2.53813C65.0227 2.69931 65.1065 2.8476 65.2482 2.92497L66.2981 3.52457C66.5879 3.6922 66.9486 3.47944 66.9486 3.14418V2.45431C66.9486 2.1126 67.3158 1.89984 67.6121 2.06747L69.6732 3.25378L71.7279 4.43364C72.0242 4.60127 72.0242 5.03324 71.7279 5.20087L69.6732 6.38073L67.6121 7.56704C67.3158 7.73467 66.9486 7.52191 66.9486 7.1802V6.83849C66.9486 5.11061 65.0807 4.02746 63.5864 4.8914L61.3255 6.18731L59.0969 7.46388C57.5961 8.32782 57.5961 10.5006 59.0969 11.3645L61.3255 12.6411L63.5864 13.937C65.0807 14.7945 66.9486 13.7178 66.9486 11.9899V11.6998C66.9486 11.5386 66.8649 11.3903 66.7232 11.3129L65.6733 10.7133C65.3834 10.5457 65.0227 10.7585 65.0227 11.0937V11.7836C65.0227 12.1253 64.6556 12.3381 64.3593 12.1704L62.2981 10.9841L60.2434 9.80426C59.9471 9.63663 59.9471 9.20466 60.2434 9.03703L62.2981 7.85717L64.3593 6.67086C64.6556 6.50323 65.0227 6.71599 65.0227 7.0577V7.39941C65.0227 9.12729 66.8906 10.2104 68.385 9.3465L70.6458 8.05059L72.8744 6.77402C74.3752 5.90363 74.3752 3.73733 72.8744 2.87339Z" fill="black"/><path d="M58.2531 3.29906L53.0358 14.0854H50.8716L52.8233 10.0559L49.7509 3.29906H51.973L53.944 7.82508L56.0953 3.29906H58.2531Z" fill="black"/><path d="M6.08684 7.12873C6.08684 5.83926 5.15288 4.93664 4.00636 4.93664C2.85985 4.93664 1.92589 5.8586 1.92589 7.12873C1.92589 8.38596 2.85985 9.32082 4.00636 9.32082C5.15288 9.32082 6.08684 8.41819 6.08684 7.12873ZM6.10616 10.9584V9.96555C5.53934 10.6554 4.69556 11.0809 3.69075 11.0809C1.59095 11.0809 0 9.39819 0 7.12873C0 4.87861 1.65536 3.16362 3.73584 3.16362C4.71488 3.16362 5.53934 3.59559 6.10616 4.26611V3.29901H7.98696V10.9584H6.10616V10.9584Z" fill="black"/><path d="M17.1339 9.25639C16.4769 9.25639 16.2901 9.01139 16.2901 8.36666V4.96892H17.5011V3.29906H16.2901V1.42934H14.3643V3.29906H11.878V2.53828C11.878 1.89355 12.1228 1.64855 12.7991 1.64855H13.2242V0.165665H12.2967C10.7057 0.165665 9.9521 0.687897 9.9521 2.28038V3.30551H8.88287V4.96892H9.9521V10.9585H11.878V4.96892H14.3643V8.72126C14.3643 10.2815 14.9633 10.9585 16.522 10.9585H17.514V9.25639H17.1339Z" fill="black"/><path d="M24.0509 6.43876C23.9157 5.44587 23.1041 4.84627 22.1508 4.84627C21.2039 4.84627 20.4181 5.42653 20.2249 6.43876H24.0509ZM20.2056 7.63152C20.3408 8.76625 21.1524 9.41098 22.183 9.41098C22.9946 9.41098 23.6194 9.03059 23.9865 8.41809H25.9639C25.5066 10.0428 24.0509 11.0808 22.1379 11.0808C19.8256 11.0808 18.2024 9.45611 18.2024 7.14152C18.2024 4.82693 19.9157 3.15707 22.183 3.15707C24.4631 3.15707 26.1185 4.83983 26.1185 7.14152C26.1185 7.30915 26.1056 7.47678 26.0734 7.63152H20.2056V7.63152Z" fill="black"/><path d="M38.3824 7.12863C38.3824 5.89074 37.4485 4.93654 36.3019 4.93654C35.1554 4.93654 34.2215 5.8585 34.2215 7.12863C34.2215 8.38585 35.1554 9.32072 36.3019 9.32072C37.4485 9.32072 38.3824 8.37296 38.3824 7.12863ZM32.3214 14.0853V3.29892H34.2021V4.2918C34.769 3.58905 35.6127 3.15707 36.6176 3.15707C38.6851 3.15707 40.3083 4.85917 40.3083 7.10928C40.3083 9.3594 38.6529 11.0744 36.5725 11.0744C35.6063 11.0744 34.8141 10.694 34.2601 10.0493V14.0788H32.3214V14.0853Z" fill="black"/><path d="M47.0903 7.12873C47.0903 5.83926 46.1563 4.93664 45.0098 4.93664C43.8633 4.93664 42.9293 5.8586 42.9293 7.12873C42.9293 8.38596 43.8633 9.32082 45.0098 9.32082C46.1563 9.32082 47.0903 8.41819 47.0903 7.12873ZM47.1096 10.9584V9.96555C46.5428 10.6554 45.699 11.0809 44.6942 11.0809C42.5944 11.0809 41.0034 9.39819 41.0034 7.12873C41.0034 4.87861 42.6588 3.16362 44.7393 3.16362C45.7183 3.16362 46.5428 3.59559 47.1096 4.26611V3.29901H48.9904V10.9584H47.1096V10.9584Z" fill="black"/><path d="M28.9273 4.04681C28.9273 4.04681 29.4039 3.15707 30.5827 3.15707C31.0851 3.15707 31.4071 3.33115 31.4071 3.33115V5.28469C31.4071 5.28469 30.6986 4.84627 30.048 4.93654C29.3975 5.0268 28.9853 5.61995 28.9853 6.41942V10.9519H27.04V3.29892H28.9208V4.04681H28.9273Z" fill="black"/></svg> or<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 452.9 101.10000000000001" width="2500" height="558"><path d="M79.7 0H57.4c0 18.3-8.4 35-23 46l-8.8 6.6 34.2 46.6h28.1L56.4 56.3C71.3 41.5 79.7 21.5 79.7 0zM0 0h22.8v99.2H0zM94.5 0H116v99.2H94.5zM304.6 28.7c-8.2 0-16 2.5-21.2 9.6v-7.7H263v68.6h20.7v-36c0-10.4 7-15.5 15.4-15.5 9 0 14.2 5.4 14.2 15.4v36.2h20.5V55.6c0-16-12.7-26.9-29.2-26.9zM181 30.6V35c-5.8-4-12.8-6.3-20.4-6.3-20 0-36.2 16.2-36.2 36.2s16.2 36.2 36.2 36.2c7.6 0 14.6-2.3 20.4-6.3v4.4h20.5V30.6zm-18.7 51.9c-10.3 0-18.6-7.9-18.6-17.6s8.3-17.6 18.6-17.6 18.6 7.9 18.6 17.6-8.3 17.6-18.6 17.6zM233.3 39.5v-8.9h-21v68.6h21.1v-32c0-10.8 11.7-16.6 19.8-16.6h.2v-20c-8.3 0-16 3.6-20.1 8.9zM397.6 30.6V35c-5.8-4-12.8-6.3-20.4-6.3-20 0-36.2 16.2-36.2 36.2s16.2 36.2 36.2 36.2c7.6 0 14.6-2.3 20.4-6.3v4.4h20.5V30.6zm-18.7 51.9c-10.3 0-18.6-7.9-18.6-17.6s8.3-17.6 18.6-17.6 18.6 7.9 18.6 17.6c.1 9.7-8.3 17.6-18.6 17.6zM434 32.6c0-1-.7-1.6-1.8-1.6h-1.9v5.2h.9v-1.9h1l.8 1.9h1l-.9-2.1c.6-.3.9-.8.9-1.5zm-1.8.8h-1v-1.6h1c.6 0 .9.3.9.8s-.2.8-.9.8z"/><path d="M431.9 28.8c-2.7 0-4.9 2.2-4.9 4.9.1 2.7 2.2 4.9 4.9 4.9s4.9-2.2 4.9-4.9-2.2-4.9-4.9-4.9zm0 8.9c-2.2 0-3.9-1.8-3.9-4s1.8-4 3.9-4c2.2 0 3.9 1.8 3.9 4s-1.8 4-3.9 4zM440 74.9c-7.1 0-12.9 5.8-12.9 12.9s5.8 12.9 12.9 12.9 12.9-5.8 12.9-12.9c0-7.2-5.8-12.9-12.9-12.9z"/></svg>`;
        document.querySelector('.afterpay-text1').innerHTML = 'or 4 instalments of ';
        document.querySelector('.afterpay-text2').innerHTML = ' with ' ;
        document.querySelector('.afterpay-logo').style.display = "none";
        document.querySelector('.afterpay-link').style.display = "none";
        document.querySelector('.afterpay-text3').innerHTML = `${payIcons}`;
      }
    },100);
  }
  
  // mobile utility bar slider
  const utilitySlider = document.querySelector('#store-messages');
  if(utilitySlider){
    if (window.innerWidth <= 767) {
      new Swiper(utilitySlider, {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        }
      });
    }
  }
  
  var firstSection = document.body.querySelector('#page-content .shopify-section:first-child');
  if(firstSection) {
    var firstBgSet = firstSection.querySelector('[data-bgset]');
    
    if (firstBgSet) {
      var bgSets = firstBgSet.dataset.bgset.split(',');
      if(bgSets) {
        for (var i = 0; i < bgSets.length; i++) {
          var widthMatch = bgSets[i].match(/ [0-9]+w/g);
          var heightMatch = bgSets[i].match(/ [0-9]+h/g);
          
          if(widthMatch && heightMatch) {
            var width = parseInt(widthMatch[0].replace('w', '').trim());
            var height = parseInt(heightMatch[0].replace('h', '').trim());
            
            if (width >= window.innerWidth && height >= window.innerHeight) {
              firstBgSet.style.backgroundImage = "url('" + bgSets[i].trim().split(' ')[0] + "')";
              firstBgSet.classList.remove('fade-in');
              break;
            }
          }
        }
      } 
    } else if (firstSection.querySelector('[data-src]')) {
      var firstDataSrc = firstSection.querySelector('[data-src]');
      var widths = JSON.parse(firstDataSrc.dataset.widths);
      for (var i = 0; i < widths.length; i++) {
        var width = parseInt(widths[i]);
        if (width >= window.innerWidth) {
          firstDataSrc.setAttribute('src', firstDataSrc.dataset.src.replace('{width}', width));
          firstDataSrc.classList.remove('fade-in');
          break;
        }
      }
    }
  }
  
  if (window.innerWidth > 767) {
    //Calculate the viewport height
    theme.calc100vh = function() {
      var nav = document.getElementById('site-control');
      document.documentElement.style.setProperty('--viewport-height-first-section',
      `${(nav.dataset.opacity === 'opaque') ? window.innerHeight - nav.clientHeight : window.innerHeight}px`);
      document.documentElement.style.setProperty('--viewport-height',
      (nav.dataset.opacity.indexOf('opaque') > -1 && nav.dataset.positioning === "sticky") ? `calc(100vh - ${nav.clientHeight}px)` : "100vh");
    }
    theme.calc100vh();
  }
  
  $(document).on('click','#filterTrigger',function(){
    $(this).text().includes('Show Filters') ? $(this).text('Hide Filters').addClass('active') : $(this).text('Show Filters').removeClass('active');
    if (window.innerWidth <= 767 ) {
      $('.theme-filter-container .cc-product-filter').addClass('-in');
      $('.theme-filter-container .cc-product-filter').css("display","block");
      $('#shopify-section-header').hide();
    }else{
      $('.theme-filter-container .cc-product-filter').animate({width: 'toggle'});
      $('#shopify-section-header').show();
    }
  });
  
  $(document).on('click','#FacetsForm .closePopup',function(){
    $('#filterTrigger').removeClass('active');
    $('.theme-filter-container .cc-product-filter').removeClass('-in');
    $('#shopify-section-header').show();
    $('#filterTrigger').text('Show filters');
  });
  
  
  // collection description toggle on mobile
  //   if($(window).width() < 767){
  //     $('.colletion-faqs-section1 .faq-que1').click(function(){
  //       $(this).toggleClass('active');
  //       $(this).siblings('.faq-ans1').slideToggle('300');
  //     });
  //   }
  // collection description hide on mobile 
  if (window.innerWidth <= 767 ) {
    $('.collection-header .faq-ans1').hide();
  }
  
  $('.colletion-faqs-section .faq-que').click(function(){
    $(this).toggleClass('active');
    $(this).siblings('.faq-ans').slideToggle('300');
  });
  
  $(document).on('change', '.cust-filter-header .plp-accordion-item__panel-grid-Sortby input',function(){
    var currVal = $(this).val();
    var searchParams = new URLSearchParams(window.location.search);
    searchParams.set("sort_by",currVal);
    window.location.search =  searchParams.toString();
  })
  if(window.innerWidth > 767){
    $('.theme-filter-container .cc-product-filter').css('display','none');
  }
  // toxic free home {page} tabs
  $(document).on('click','#expandAccordion',function(){
    $(this).siblings('.list-wrapper').css('max-height','100%');
    $(this).addClass('active').text('- See Less');
  });
  $(document).on('click','#expandAccordion.active',function(){
    $(this).siblings('.list-wrapper').removeAttr('style');
    $(this).removeClass('active').text('+ Expand');
  });
  if($(window).width() < 767){
      // let toxicfreePriceWrapper = $('.toxic-free-price-wrapper');
      // $(toxicfreePriceWrapper).slick({
      //   dots:true,
      //   arrows:true,
      //   adaptiveHeight: true,
      //   prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
      //   nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>"
      // });
      new Swiper('.toxic-free-price-wrapper-mobile',{
        autoHeight: true,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
        }
      })
  }
  $(document).on('change','.plan-selection-wrapper select[name="id"]',function(){
    var price = $(this).find(':selected').attr('data-price'),
    comPrice = $(this).find(':selected').attr('data-compare-price');
    $('#custMobPrice').text(price);
    $('#custMobComPrice').text(comPrice);
  });
  $(".toxic-free-banner-get-started").on('click', function() {
    $('html, body').animate({
      scrollTop: $( '#toxic-free-banner-get-started').offset().top - 150
    }, 'slow');
  });
  $('.plan-selection').change(function() {
    var planselection = $(this).val();
    $("#hiddenmonthyearlydata").val(planselection);
  });
  $(document).on('click','.plan-selection-swatch .swetch-wrapper input',function(){
    var price = $(this).attr('data-price'),
    comPrice = $(this).attr('data-compare-price');
    $('#custMobPrice').text(price);
    $('#custMobComPrice').text(comPrice);
    var dataurlswatches = $(this).attr('data-url');
    $('.mobile-swatches-dataurl').attr('href',dataurlswatches);
  });
  
  // icon with text slider on mobile
  if (window.innerWidth <= 767) {
    new Swiper(".icon-with-text-slider", {
      slidesPerView: 3,
      spaceBetween: 20,
      centeredSlides: false,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: { 
        375: {
          slidesPerView: 2,
        }
      }
    });
    new Swiper(".text-column-img-slider.slider", {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 0,
      navigation: { 
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }
    });
    if (document.querySelector('.text-column-img-slider .rimage-outer-wrapper')) {
      let textColTopPosition = document.querySelectorAll('.text-column-img-slider .rimage-outer-wrapper')[1].clientHeight;
      document.querySelector('.swiper-arrow-wrapper').style.top = `${textColTopPosition}px`;
    }
  }
  
  // logo section slider
  new Swiper(".featured-logo-wrapper.swiper", {
    slidesPerView: 6,
    spaceBetween: 0,
    breakpoints: { 
      375: {
        slidesPerView: 2,
      },
      767: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
      1199: {
        slidesPerView: 6,
      }
    }
  });
  
  // ingredient glossary filter script
  let ingredientContent = document.querySelectorAll('.filter-card');
  let ingredientMainWrapper = document.querySelector('#filterContent');
  ingredientContent.forEach(ele => {
    ingredientMainWrapper.appendChild(ele);
  });
  
  let filterTrigger = document.querySelectorAll('.ingredient-glossary-filter-section .filter-group li span');
  let fillterCards = document.querySelectorAll(`#filterContent [data-category]`);
  filterTrigger.forEach(btn => {
    btn.addEventListener('click', (e) => {
      
      filterTrigger.forEach(btns => {
        btns.classList.remove('active');
      });
      e.target.classList.add('active');
      
      let fillterCardsAttr = e.target.getAttribute('data-filter');
      fillterCards.forEach(card => {
        let cardAttr = card.getAttribute('data-category');
        if (cardAttr == fillterCardsAttr) {
          card.classList.add('visible');
        }else{
          card.classList.remove('visible');
        }
      });
    })
  });
  
  // customer address page
  const addAddressBtn = document.querySelector('#addAddressTrigger');
  const addAddresstargete = document.querySelector('#add_address');
  const headerEle = document.querySelector('#shopify-section-header');
  if (addAddressBtn) {
    addAddressBtn.addEventListener('click', (e) => {
      e.target.classList.toggle('active');
      addAddresstargete.classList.toggle('active');
      setTimeout(() => {
        e.target.classList.contains('active') ? headerEle.style.display = 'none' : headerEle.style.display = 'block';
      }, 50);
    })
  }
  
  const addressCloseBtn = document.querySelector('.add_address .btnclose');
  if (addressCloseBtn) { 
    addressCloseBtn.addEventListener('click', () => {
      addAddressBtn.classList.remove('active');
      addAddresstargete.classList.remove('active');
      headerEle.style.display = 'block';
    })
  }

  // on keypress submit form
  window.cacheTimeout = null;
  $(document).on('keyup','#FacetsForm .cc-price-range__input-row input', function(event){
    clearTimeout(window.timeout);
    window.timeout = setTimeout(function(){
    $('#FacetsForm').submit(); 
    }, 1000); 
  });
  
  $(".subscriptions-scrollto").on('click', function() {
    var data_id = $(this).data('id');
    $('html, body').animate({
        scrollTop: $( '#' + data_id).offset().top - 150
    }, 'slow');
    $('#' + data_id).find('.acc-title-wrapper').toggleClass('active');
    $('#' + data_id).find('.acc-content-wrapper').css("display","block");
  
  });
  $('.acc-title,.acc-title-number').click(function(){
    $(this).toggleClass('active');
    $(this).siblings('.acc-content-wrapper').slideToggle('300');
  });

  $(document).on('click','.cust-recipe-lib-section .bottom-load-more button',function(){
    var targetele = $('.cust-recipe-lib-wrapper .recipie-art-wrapper');
    $(targetele).fadeIn(100);
    $(this).hide();
  });


  $(".ambassador-program-scrollto").on('click', function() {
    $('html, body').animate({
        scrollTop: $( '.ambassador-program-lc-signup-container').offset().top - 100
    });
  });

});
